import { Tab, Tabs } from "@mui/material";
import { IdValueOption } from "../../types/common";
import clsx from "clsx";

type HorizontalTabProps = {
    tabArray: IdValueOption[];
    tabValue: string;
    setTabValue: (value: string) => void
}

const HorizontalTabs = ({
    tabArray,
    tabValue,
    setTabValue,
}: HorizontalTabProps) => {
    return (
        <Tabs
            value={tabValue}
            onChange={(_, newValue) => setTabValue(newValue)}
            className="!min-h-0"
            TabIndicatorProps={{
                style: { display: 'none' }
            }}
            sx={{
                '& .MuiTabs-flexContainer': {
                    gap: '8px',
                }
            }}
        >
            {
                tabArray.map(tab => {
                    const isSelected = tabValue === tab.id;
                    return <Tab
                        id={tab.id}
                        key={tab.id}
                        value={tab.id}
                        label={
                            <div className={clsx(
                                "flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200",
                                isSelected 
                                    ? "bg-backgroundBlue text-nanonetsBlue font-semibold" 
                                    : "text-greyishBlue hover:bg-backgroundBlueLight hover:text-greyishBlueMid"
                            )}>
                                <span className="text-sm">{tab.value}</span>
                                {tab.count !== undefined && tab.count !== null && (
                                    <span className={clsx(
                                        "px-2 py-0.5 rounded-full text-xs font-medium transition-colors",
                                        isSelected
                                            ? "bg-nanonetsBlue/10 text-nanonetsBlue"
                                            : "bg-backgroundGrey text-greyishBlue"
                                    )}>
                                        {tab.count}
                                    </span>
                                )}
                            </div>
                        }
                        className="!normal-case !px-0 !py-0 !min-w-0 !min-h-0"
                        sx={{
                            textTransform: 'none',
                            padding: 0,
                            minWidth: 0,
                            minHeight: 0,
                            "&.Mui-selected": {
                                color: 'transparent'
                            }
                        }}
                    />
                })
            }    
        </Tabs>
    )
}

export default HorizontalTabs;